import axiosClient from ".";
class PoolAPI {
  static getPoolAmount() {
    return axiosClient.get("/pool_amount.json");
  }

//   static logout() {
//     return axiosClient.delete("/users/sign_out.json");
//   }
}

export default PoolAPI;
